import React from "react"
import { Outlet, Navigate } from "react-router-dom"
import { useSelector } from "react-redux"

const AdminRoute = () => {
    const { userInfo } = useSelector((state) => state.auth)
    const userType = userInfo && userInfo[1]?.InfoField2


    return userInfo && userType === "3" ? (
        <Outlet />
    ) : (
        <Navigate to="/login" replace />
    )
}

export default AdminRoute